import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";

const StyledAccountDetailsLoader = styled(ContentLoader)`
  height: 70px;
  width: 280px;
`;

export const AccountDetailsLoader = () => (
  <StyledAccountDetailsLoader height={70} width={280}>
    <path d="m4,36c0,-18.23204 14.76796,-33 33,-33c18.23204,0 33,14.76796 33,33c0,18.23204 -14.76796,33 -33,33c-18.23204,0 -33,-14.76796 -33,-33z" />
    <rect height="11" width="93" x="85" y="11" />
    <rect height="11" width="58.999999" x="85" y="41.015621" />
  </StyledAccountDetailsLoader>
);
